namespace RedBullMOBILE360.AutomaticReports {
    export interface ReportPartForm {
        ReportId: Serenity.LookupEditor;
        PartName: Serenity.StringEditor;
        PartTitle: Serenity.StringEditor;
        PartType: Serenity.EnumEditor;
        PartQuery: Serenity.TextAreaEditor;
        IsAttachment: Serenity.BooleanEditor;
    }

    export class ReportPartForm extends Serenity.PrefixedContext {
        static formKey = 'AutomaticReports.ReportPart';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportPartForm.init)  {
                ReportPartForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.TextAreaEditor;
                var w4 = s.BooleanEditor;

                Q.initFormType(ReportPartForm, [
                    'ReportId', w0,
                    'PartName', w1,
                    'PartTitle', w1,
                    'PartType', w2,
                    'PartQuery', w3,
                    'IsAttachment', w4
                ]);
            }
        }
    }
}
